import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./dashBoard.css";

const API_URL = process.env.REACT_APP_API_URL || "https://api.transtrackglobal.in";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    totalResources: 0,
    activeResources: 0,
    pipelineResources: 0,
    inactiveResources: 0,
    upcomingRenewals: 0,
    totalMonthlyMargin: 0,
    totalMarginPercentage: 0,
    lastWorkingInNext30Days: 0,
  });

  const userType = localStorage.getItem("userType") || "admin";

  useEffect(() => {
    const getDashboardData = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/api/getdashboardData`
        );
        setDashboardData(res.data[0] || {});
      } catch (error) {
        console.error("Dashboard API error", error);
      }
    };

    getDashboardData();
  }, []);

  return (
    <div className="dashboard-container">
      {/* ================= HEADER ================= */}
      <div className="dashboard-header">
        <h5 className="mb-0 fw-semibold text-secondary">Dashboard</h5>

        <div className="dashboard-actions">
          <Link to="/user" className="btn gradient-btn">
            <i className="bi bi-people"></i> Manage Records
          </Link>

          <Link to="/monthlyMIS" className="btn gradient-btn">
            <i className="bi bi-bar-chart-line"></i> Monthly MIS
          </Link>
        </div>
      </div>

      {/* ================= STAT CARDS ================= */}
      <div className="row g-4 mt-1">
        <StatCard
          title="Total Resources"
          value={dashboardData.totalResources || 0}
          icon="bi-people-fill"
          gradient="grad-blue"
          link="/user?filter=all"
        />

        <StatCard
          title="Active Resources"
          value={dashboardData.activeResources || 0}
          icon="bi-person-check-fill"
          gradient="grad-green"
          link="/user?filter=active"
        />

        <StatCard
          title="Pipeline Resources"
          value={dashboardData.pipelineResources || 0}
          icon="bi-hourglass-split"
          gradient="grad-teal"
          link="/user?filter=pipeline"
        />

        <StatCard
          title="Upcoming Renewals (in next 30 days)"
          value={dashboardData.upcomingRenewals || 0}
          icon="bi-calendar-event-fill"
          gradient="grad-orange"
          link="/user?filter=renewal30"
        />
        
        <StatCard
          title="Last working days (in next 30 days)"
          value={dashboardData.lastWorkingInNext30Days || 0}
          icon="bi bi-file-earmark-bar-graph"
          gradient="grad-orange"
          link="/user?filter=lastworking30"
        />
        
        {userType !== "hr manager" && (
          <>
            <StatCard
              title="Total Margin"
              value={`₹ ${dashboardData.totalMonthlyMargin || 0}`}
              icon="bi-currency-rupee"
              gradient="grad-purple"
            />

            <StatCard
              title="Total Margin %"
              value={`${dashboardData.totalMarginPercentage || 0}%`}
              icon="bi-graph-up-arrow"
              gradient="grad-indigo"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Dashboard;

/* ===================== STAT CARD ===================== */
const StatCard = ({ title, value, icon, gradient, link }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <div className="col-xl-4 col-md-6">
      <div
        className={`stat-card ${gradient}`}
        onClick={handleClick}
        style={{
          cursor: link ? "pointer" : "default",
        }}
      >
        <div className="stat-icon">
          <i className={`bi ${icon}`}></i>
        </div>

        <div className="stat-content">
          <span className="stat-title">{title}</span>
          <h4 className="stat-value">{value}</h4>
        </div>
      </div>
    </div>
  );
};
